import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, X, Check } from 'lucide-react';
import { useCart } from '../../context/CartContext';

const PrimeDrawer = ({ isOpen, onClose }) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { cartItems, cartTotal, updateItemQuantity, removeItem, cartCount } = useCart();

    if (!isOpen) return null;



    const handleCheckout = () => {
        onClose();
        navigate('/checkout');
    };

    return (
        <>
            <div className="fixed inset-0 z-[9999] bg-black/50 backdrop-blur-sm transition-opacity cursor-pointer" onClick={onClose} />
            <div className="fixed top-0 right-0 z-[10000] h-[100dvh] w-full md:w-[450px] bg-white shadow-2xl flex flex-col animate-in slide-in-from-right duration-300 pb-[env(safe-area-inset-bottom)]">
                {isLoading ? (
                    <div className="flex-1 flex flex-col items-center justify-center p-12 text-center space-y-6">
                        <Loader2 className="animate-spin text-[#00A8E1]" size={48} />
                        <p className="font-bold text-gray-600">Redirecting to Amazon...</p>
                    </div>
                ) : (
                    <>
                        {/* Header */}
                        <div className="flex items-center justify-between p-6 border-b bg-white relative z-10">
                            <h2 className="text-xl font-bold text-gray-900">Cart <span className="text-gray-500 font-normal text-base">{cartCount} items</span></h2>
                            <div className="flex items-center gap-4">
                                <div className="flex flex-col items-end leading-none select-none">
                                    <span className="text-[10px] font-bold italic text-[#00A8E1] tracking-wide">Buy with</span>
                                    <div className="relative h-6 w-16">
                                        <svg viewBox="0 0 100 30" className="w-full h-full text-[#00A8E1] fill-current">
                                            <path d="M14.8,23.4C13.6,25.6,11.2,27,8.2,27c-4.6,0-7.8-3.2-7.8-8.1c0-5,3.4-8.6,8.2-8.6c2.8,0,5.2,1.4,6.4,3.6v-3.2h3.2v15.8h-3.4V23.4z M11.4,18.9c0-3.2-1.8-5.4-4.6-5.4c-2.8,0-4.6,2.2-4.6,5.4c0,3.2,1.8,5.4,4.6,5.4C9.6,24.3,11.4,22.1,11.4,18.9z" />
                                            <path d="M22.6,10.7h3.2v2.8c1-2,3.2-3.2,5.6-3.2c0.4,0,0.8,0,1.2,0.2v3.4c-0.4-0.2-1-0.2-1.6-0.2c-2.8,0-5.2,2-5.2,5.6v7.2h-3.2V10.7z" />
                                            <path d="M37.6,10.7h3.4v15.8h-3.4V10.7z M37.6,4.6h3.4v3.4h-3.4V4.6z" />
                                            <path d="M46.8,10.7h3.2v2.6c1.2-2,3.6-3,6-3c2.6,0,4.8,1.2,5.8,3.4c1.2-2.2,3.6-3.4,6.2-3.4c4.2,0,6.8,2.8,6.8,7.6v8.6h-3.4v-8c0-3.2-1.4-4.8-3.8-4.8c-2.6,0-4.6,1.8-4.6,4.8v8h-3.4v-8c0-3.2-1.4-4.8-3.8-4.8c-2.6,0-4.6,1.8-4.6,4.8v8h-3.4V10.7z" />
                                            <path d="M82.8,18.9c0,3.4,2.6,5.4,5.8,5.4c2.2,0,3.8-1,4.8-2.6l2.6,1.8c-1.8,2.6-4.4,4-7.6,4c-5.2,0-9-3.6-9-8.6c0-5.2,3.6-8.6,8.6-8.6c5,0,8.2,3.6,8.2,8.6H82.8z M87.8,13.3c-2.4,0-4.4,1.4-5,3.4h9.8C92.2,14.7,90.2,13.3,87.8,13.3z" />
                                            <path d="M96,28.5c-0.6-0.8-2.4-2.2-4.6-1.4c0,0,0.6,1.2,1,1.4c1.2,0.6,2.8,0.2,3.6-0.6L96,28.5z M18.4,28.8c5.8,3.8,18.2,4.8,28.8,1.2c5.6-2,9.6-5.2,10.2-5.8l-2.4-1.6c-0.2,0.2-3.8,3.2-8.6,4.8c-9.2,3-19.8,2.2-24.6-1L18.4,28.8z" />
                                        </svg>
                                    </div>
                                </div>
                                <button onClick={onClose} className="text-gray-400 hover:text-black">
                                    <X size={24} />
                                </button>
                            </div>
                        </div>

                        {/* --- SCARCITY TIMER --- */}
                        {cartItems.length > 0 && <ReservationTimer />}



                        {/* Items */}
                        <div className="flex-1 overflow-y-auto p-6 space-y-6 bg-white">
                            {cartItems.length === 0 ? (
                                <div className="text-center text-gray-500 mt-12">
                                    Your cart is empty.
                                </div>
                            ) : (
                                cartItems.map((item) => (
                                    <div key={item.id} className="border-b border-gray-100 pb-6 last:border-0">
                                        <div className="flex gap-4">
                                            <div className="w-24 h-24 border border-gray-200 rounded-sm p-2 flex items-center justify-center bg-white shrink-0">
                                                <img src={item.image} alt={item.name} className="w-full h-full object-contain" />
                                            </div>
                                            <div className="flex-1 min-w-0">
                                                <div className="flex justify-between items-start gap-2">
                                                    <h3 className="font-medium text-sm leading-snug text-gray-900 line-clamp-2">{item.title || item.name}</h3>
                                                    {item.variant && <div className="text-xs text-gray-500 mt-0.5">{item.variant}</div>}
                                                    <div className="font-bold text-lg text-gray-900 whitespace-nowrap">{(Number(item.price) || 0).toFixed(2)}€</div>
                                                </div>
                                                <div className="text-sm text-gray-500 mt-0.5">Color: {item.color}</div>
                                                <div className="flex flex-col gap-1 mt-1">
                                                    <div className="flex items-center gap-1 text-[#00A8E1] text-xs font-bold">
                                                        <Check size={14} strokeWidth={3} />
                                                        <span className="italic text-sm">prime</span>
                                                    </div>
                                                    {item.isSubscription && (
                                                        <div className="inline-flex items-center gap-1 bg-[#00f2ea]/10 text-[#00a6a0] text-xs font-black px-2 py-0.5 rounded-full w-fit">
                                                            <span>🔄 Abonnement Mensuel</span>
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="flex items-center gap-3 mt-4">
                                                    {/* Quantity Stepper */}
                                                    <div className="flex items-center border border-gray-300 rounded bg-gray-50 shadow-sm h-8">
                                                        <button
                                                            onClick={() => updateItemQuantity(item.id, Math.max(1, (item.qty || 1) - 1))}
                                                            className="px-3 h-full text-gray-600 hover:bg-gray-200 font-medium flex items-center justify-center bg-gray-100 border-r border-gray-300 rounded-l"
                                                        >
                                                            −
                                                        </button>
                                                        <div className="px-3 h-full bg-white text-sm font-medium min-w-[2rem] flex items-center justify-center">
                                                            {item.qty || 1}
                                                        </div>
                                                        <button
                                                            onClick={() => updateItemQuantity(item.id, (item.qty || 1) + 1)}
                                                            className="px-3 h-full text-gray-600 hover:bg-gray-200 font-medium flex items-center justify-center bg-gray-100 border-l border-gray-300 rounded-r"
                                                        >
                                                            +
                                                        </button>
                                                    </div>

                                                    {/* Delete Button */}
                                                    <button
                                                        onClick={() => removeItem(item.id)}
                                                        className="px-3 h-8 border border-gray-300 rounded bg-white text-xs font-medium text-gray-700 hover:bg-gray-50 shadow-sm"
                                                    >
                                                        Delete
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}

                            <button onClick={onClose} className="w-full text-center text-[#007185] text-sm hover:underline hover:text-[#C7511F] mt-4 font-medium">
                                Continue shopping
                            </button>
                        </div>

                        {/* Footer */}
                        {cartItems.length > 0 && (
                            <div className="p-6 border-t border-gray-200 bg-gray-50 space-y-4">
                                <div className="flex justify-between items-center font-bold text-lg text-gray-900">
                                    <span>Subtotal</span>
                                    <span>{cartTotal.toFixed(2)}€</span>
                                </div>
                                <div className="text-xs text-gray-500">Taxes are calculated at checkout.</div>

                                <button
                                    onClick={handleCheckout}
                                    className="w-full py-3 bg-[#00A8E1] hover:bg-[#008dbd] text-white text-[16px] font-bold rounded-lg shadow-sm transition-all"
                                >
                                    Proceed to checkout
                                </button>

                                <div className="flex justify-center gap-4 text-[11px] text-[#007185]">
                                    <a href="#" className="hover:underline hover:text-[#C7511F]">Terms of service</a>
                                    <span className="text-gray-300">|</span>
                                    <a href="#" className="hover:underline hover:text-[#C7511F]">Privacy policy</a>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </>
    );
};

const ReservationTimer = () => {
    const [timeLeft, setTimeLeft] = useState(600); // 10 minutes

    React.useEffect(() => {
        if (!timeLeft) return;
        const intervalId = setInterval(() => {
            setTimeLeft(timeLeft - 1);
        }, 1000);
        return () => clearInterval(intervalId);
    }, [timeLeft]);

    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;

    return (
        <div className="bg-orange-50 border-b border-orange-100 p-3 flex items-center justify-center gap-2 text-sm text-orange-800 font-medium animate-pulse">
            <span role="img" aria-label="timer">⏳</span>
            Stock réservé pendant <span className="font-bold font-mono">{String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}</span>
        </div>
    );
};

export default PrimeDrawer;
